import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ResourceOperationEfficiencyController } from './resource-operation-efficiency.controller';
import { ResourceOperationEfficiencyService } from './resource-operation-efficiency.service';
import { resourceOperationEfficiency} from './resource-operation-efficiency.entity';
import { ResourceOperationEfficiencyAdapter } from './dto/resource-operation-efficiency.adapter'
import { ResourceOperationEfficiencyLog } from './resource-op-efficiency-log.entity';
@Module({
  imports: [
    TypeOrmModule.forFeature([resourceOperationEfficiency,ResourceOperationEfficiencyLog]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [ResourceOperationEfficiencyController],
  providers: [ResourceOperationEfficiencyService,ResourceOperationEfficiencyAdapter,ApplicationExceptionHandler]
})
export class ResourceOperationEfficiencyModule {}
